import {getAssetPath} from "../../../../utils/get-asset-path.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const USER_IMAGE = getAssetPath("img/user.png");

export const getAttachUrl = (id) => `${API_KEEPER}/ged/attach/${id}`;

export const clearCpf = (cpf) => (cpf ?? "").replace(/\D/g, "");

export const errMessageI18N = (message, defaultMessage = "Não foi possível salvar.") => {
    const i18n = {
        "missing.name": "O campo \"Nome\" é obrigatório.",
        "missing.face": "Selecione uma foto.",
        "missing.watchlists": "O campo \"Lista de monitoramento\" é obrigatório.",
        "facegateway.watchlist.limit.reached": "Limite de listas de monitoramento cadastradas atingido.",
        "facegateway.not.configured": "Sistema de reconhecimento facial não configurado.",
        "facegateway.image.type.unsupported": "Tipo de arquivo inválido. Envie apenas arquivos JPEG.",
        "facegateway.image.does.not.have.human.face": "Rosto humano não detectado na imagem.",
        "facegateway.unprocessable.image": "Não foi possível processar a imagem.",
        "cpf.format.invalid": "Formato do CPF inválido.",
        "cpf.already.used": "Esse CPF já está em uso"
    };

    return i18n[message] ?? defaultMessage;
};
